/**
 * @file localization related utility functions
 */ /**
 * get locale from context or env.
 * Note: The returned value of this function is not a typical locale. A typical locale = language + region, while this
 * function might return "en" and it's from document.documentElement.lang
 * @param {Object} serverContext Server Context
 * @returns {String} locale.
 */export var getContextLocale=function getContextLocale(){var serverContext=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return serverContext.CurrentLocale||document.documentElement.lang||navigator.language||'en-us';};